/**
 * Mốc thời gian của một lần gửi, dạng gọn để nhét vừa một dòng danh sách.
 *
 * Cố ý hiện GIỜ TUYỆT ĐỐI chứ không phải "3 phút trước": khi soi một lượt gửi
 * chạy hàng giờ, câu hỏi luôn là "nhóm này đi lúc mấy giờ" để đối chiếu với
 * Zalo, chứ không phải nó cách đây bao lâu.
 */
export function formatClock(iso: string | null): string {
    if (!iso) return "";

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";

    return date.toLocaleTimeString("vi-VN", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

/** Ngày gửi, chỉ dùng khi lượt gửi kéo dài qua nhiều ngày. */
export function formatDay(iso: string | null): string {
    if (!iso) return "";

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";

    return date.toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit" });
}

/** Một lần gửi tốn bao lâu. Dưới 10 giây thì hiện lẻ, dài hơn thì làm tròn. */
export function formatTook(durationMs: number | null): string {
    if (durationMs === null || durationMs < 0) return "";

    const seconds = durationMs / 1000;
    if (seconds < 10) return `${seconds.toFixed(1)}s`;
    if (seconds < 60) return `${Math.round(seconds)}s`;

    const minutes = Math.floor(seconds / 60);
    return `${minutes}p${String(Math.round(seconds % 60)).padStart(2, "0")}`;
}

/** Khoảng cách so với tin gửi trước đó — nhìn ra ngay nhịp thực tế đang chạy. */
export function formatGap(currentIso: string | null, previousIso: string | null): string {
    if (!currentIso || !previousIso) return "";

    const gapMs = new Date(currentIso).getTime() - new Date(previousIso).getTime();
    if (!Number.isFinite(gapMs) || gapMs <= 0) return "";

    const seconds = Math.round(gapMs / 1000);
    if (seconds < 60) return `+${seconds}s`;

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `+${minutes}p`;

    return `+${Math.floor(minutes / 60)}g${String(minutes % 60).padStart(2, "0")}`;
}

/** Lượt gửi có vắt qua nhiều ngày không — quyết định có hiện thêm ngày hay không. */
export function spansMultipleDays(isoList: (string | null)[]): boolean {
    const days = new Set(isoList.filter((iso): iso is string => Boolean(iso)).map((iso) => iso.slice(0, 10)));
    return days.size > 1;
}
